<template>
  <div class="pre-header">
    <div class="container">
      <div class="row">
        <div class="col-md-6 col-sm-6 additional-shop-info">
          <!-- <ul class="list-unstyled list-inline">
            <li><i class="fa fa-phone"/><span>+1 456 6717</span></li>
            <li><i class="fa fa-envelope-o"/><span>info@keenthemes.com</span></li>
          </ul> -->
        </div>
        <div class="col-md-6 col-sm-6 additional-nav">
          <ul v-if="!isLogin" class="list-unstyled list-inline pull-right">
            <li><a href="javascript:void(0)" @click="switchlang"><img src="@/assets/image/zh-CN.png" width="16px" height="11px"> 中文</a></li>
            <li><a href="javascript:void(0)" @click="openLoginModal">Login</a></li>
            <li><router-link to="/english/signup">Register</router-link></li>
          </ul>
          <ul v-if="isLogin" class="list-unstyled list-inline pull-right">
            <li><a href="javascript:void(0)" @click="switchlang"><img src="@/assets/image/zh-CN.png" width="16px" height="11px"> 中文</a></li>
            <li v-if="this.$store.getters.isEnExpire"><router-link :to="{ path: '/english/charge', query: { isshow: false }}">Membership Renewal</router-link></li>
            <li class="user"><router-link to="/english/account"><img src="@/assets/image/btc_user.png" height="16px"> {{ this.$store.getters.name }} - My BTC Account</router-link></li>
            <li><a href="javascript:void(0)" @click.prevent="logout">Logout</a></li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import commonmix from '@/utils/commonmix'
// import { delStore, delLocalStore } from '@/utils/common'
// import { removeToken } from '@/utils/auth'
import lang from 'element-ui/lib/locale/lang/zh-CN'
import locale from 'element-ui/lib/locale'

export default {
  mixins: [commonmix],
  methods: {
    logout() {
      // delStore()
      // removeToken()
      // delLocalStore()
      this.$store.dispatch('clearToken')
      this.$router.replace('/english/BTCInfo')
    },
    switchlang() {
      locale.use(lang) // 设置element语言
      sessionStorage.lang = 'zh-cn'
      this.$i18n.locale = sessionStorage.lang
      this.$router.replace('/BTCInfo')
    }
  }
}
</script>

<style scoped>
.user a{
  color: #317ab4!important;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/views/layout_en/components/PreHeader/index.vue